var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{staticClass:"notifications",attrs:{"type":"flex","justify":"center"}},[_c('a-col',{staticClass:"col",attrs:{"span":16}},[_c('NotificationsTemplate')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }